export default __webpack_public_path__ + "static/media/BrutalType-Regular.eb6c6d6d.eot";